import {AuthenticationErrorResponse, RemoteRequester} from "@eryxcoop/appyx-comm";

export default class SaporeRemoteRequester extends RemoteRequester {
    call ({ endpoint, data = undefined, retries = 1 }) {
        return super.call({ endpoint, data }).then((response) => {
            if (response instanceof AuthenticationErrorResponse) {
                if (retries > 0) {
                    this._refreshUserTokenAndRetry(endpoint, data, retries);
                } else {
                    this._authorizationManager.session().logOut();
                }
            }
            return response
        });
    }

    _refreshUserTokenAndRetry (endpoint, data, retries) {
        this._authorizationManager.session().refreshUserToken().then(() => {
            this.call({ endpoint, data, retries: retries - 1 }).then((response) => {
                return response;
            });
        });
    }

    _dataToQueryString(data) {
        let keyValuePairs = [];
        for (let i = 0; i < Object.keys(data).length; i += 1) {
            let key = Object.keys(data)[i];
            let value = Object.values(data)[i];
            if (value) {
                let encoded_value;
                if (typeof value === "object" && value.constructor === Object) {
                    encoded_value = JSON.stringify(value)
                } else {
                    encoded_value = encodeURIComponent(value)
                }
                keyValuePairs.push(`${encodeURIComponent(key)}=${encoded_value}`);
            }
        }
        return keyValuePairs.join('&');
    }
}

